<script setup>
 import {usePortalContentAndDesignStore} from "../../stores/partners/portalContentAndDesignStore";
 import {ref, computed} from "vue";
 import EditableTextField from "./portal-editable-fields/EditableTextField.vue";
 import EditableBtn from "./portal-editable-fields/EditableBtn.vue";
 import ValidationErrors from "../common/ValidationErrors.vue";

     const portalContentAndDesignStore = usePortalContentAndDesignStore();

     const emit = defineEmits(['modal-off']);

     const updateUrl = route('partners_int.custom_links.update');

     const updateRefLinkModal = ref(null)

     const props = defineProps({
         partnerCustomLink: {
             type: Object,
             required: true
         }
    })


    const error = ref(null)
    const loading = ref(false)
    const custom_link = ref(JSON.parse(JSON.stringify(props.partnerCustomLink)));
    const custom_link_backup = ref(JSON.parse(JSON.stringify(props.partnerCustomLink)));

    const updateCustomLink = () => {
            error.value = null;
            loading.value = true;

            axios
                .post(updateUrl, {link_id: custom_link.value.id, key: custom_link.value.key})
                .then(response => {
                    if (+response.data.status === 1) {
                        if (updateRefLinkModal.value) {
                            updateRefLinkModal.value.showModal = false;
                        }
                        portalContentAndDesignStore.resourcesPageSettings.custom_links = portalContentAndDesignStore.resourcesPageSettings.custom_links.map(link => {
                            if (link.id === custom_link.value.id) {
                                return {...link, key: custom_link.value.key};
                            }
                            return link;
                        });
                        emit('modal-off', 'partner_update_custom_link');
                    } else {
                        error.value = response.data?.error || response.data?.errors || 'Failed to update custom link';
                    }
                })
                .catch(resError => {
                    if (resError.response && resError.response.status === 422) {
                        error.value = resError.response?.data?.errors || 'Something went wrong';
                    } else {
                        console.log('Creating link error:', error.response);
                        error.value = resError.response?.data?.error || 'An error occurred. See console for details.';
                    }
                }).finally(() => loading.value = false);
    }

    const modalClose = () => {
            custom_link.value = {...custom_link_backup.value};
    }

    const exampleUrl = computed(() => {
        return custom_link_backup.value.url.replace(custom_link_backup.value.key, custom_link.value.key);
    })
</script>
<template>
    <modal
       :title="portalContentAndDesignStore.translationSettings.portal_translation_features_referral_url"
       :cancel_btn_title="portalContentAndDesignStore.translationSettings.portal_translation_general_cancel"
       size="small"
       name="partner_update_custom_link"
       @modalClose="modalClose"
       ref="updateRefLinkModal"
    >
        <template #toggle>
            <options-item
                :title="portalContentAndDesignStore.translationSettings.portal_translation_features_update_ref_url"></options-item>
        </template>
        <template #body>
            <div class="space-y-4">
                <validation-errors :errors="error" />
                <div>
                    <editable-text-field
                        text-type="label"
                        for-attribute="custom_link_key"
                        :v-model="portalContentAndDesignStore.translationSettings.portal_translation_features_link_key"
                        :class="['block text-sm opacity-80 mb-1.5', portalContentAndDesignStore.getTextColorClass]"
                    />
                    <input type="text"
                           v-model="custom_link.key"
                           id="custom_link_key"
                           name="custom_link_key"
                           :class="portalContentAndDesignStore.getInputStyle"
                           @keyup.enter="updateCustomLink"
                    >
                </div>
                <div class="py-3 px-4 text-sm bg-gray-100 rounded truncate">
                    <span class="opacity-60">{{ exampleUrl }}</span>
                </div>
            </div>
        </template>
        <template #footer>
            <editable-btn
                v-on:click="updateCustomLink"
                :loading="loading"
                :disabled="loading"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_update"
            />
        </template>
    </modal>
</template>
